import {
  createStyles,
  Image,
  Container,
  Title,
  Button,
  Group,
  Text,
} from "@mantine/core";
import { useHistory } from "react-router-dom";
const useStyles = createStyles((theme) => ({
  inner: {
    display: "flex",
    justifyContent: "space-between",
    paddingTop: theme.spacing.xl * 3,
    paddingBottom: theme.spacing.xl * 4,
  },

  content: {
    maxWidth: 480,
    marginRight: theme.spacing.xl * 3,

    [theme.fn.smallerThan("md")]: {
      maxWidth: "100%",
      marginRight: 0,
    },
  },

  title: {
    color: theme.colorScheme === "dark" ? theme.white : theme.black,
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    fontSize: 44,
    lineHeight: 1.2,
    fontWeight: 900,

    [theme.fn.smallerThan("xs")]: {
      fontSize: 28,
    },
  },

  control: {
    [theme.fn.smallerThan("xs")]: {
      flex: 1,
    },
  },

  image: {
    flex: 1,

    [theme.fn.smallerThan("md")]: {
      display: "none",
    },
  },

  highlight: {
    position: "relative",
    backgroundColor: theme.fn.variant({
      variant: "light",
      color: theme.primaryColor,
    }).background,
    borderRadius: theme.radius.sm,
    padding: "4px 12px",
  },
}));

export default function Hero() {
  const history = useHistory();
  const { classes } = useStyles();
  return (
    <div>
      <Container>
        <div className={classes.inner}>
          <div className={classes.content}>
            <Title className={classes.title}>
              Welcome to {""}
              <span style={{ color: "" }} className={classes.highlight}>
                Swipet{" "}
              </span>
              <br />
              Tinder for pets
            </Title>
            <Text color="dimmed" mt="md">
              🐶 Your one and only source to nations pets galore
            </Text>

            <Group mt={30}>
              <Button
                onClick={() => {
                  history.push("/login");
                }}
                radius="xl"
                size="md"
                className={classes.control}
              >
                Login
              </Button>
              <Button
                onClick={() => {
                  history.push("/register");
                }}
                variant="default"
                radius="xl"
                size="md"
                className={classes.control}
              >
                Register
              </Button>
            </Group>
          </div>
          <Image
            src={
              "https://images.unsplash.com/photo-1592194996308-7b43878e84a6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8cGV0c3xlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60"
            }
            className={classes.image}
          />
        </div>
      </Container>
    </div>
  );
}
